// Keyboard shortcut cheat sheet.
//
// Rendered by the `?` overlay. Grouped by function. Keep each description
// short — the overlay is scannable, not a manual.
/** Title / footer copy for the shortcut overlay itself. */
export const KEYBOARD_HELP_HEADER = {
    icon: '⌨️',
    zh: '键盘快捷键',
    en: 'Keyboard shortcuts',
    es: 'Atajos de teclado',
};
export const KEYBOARD_HELP_FOOTER = {
    zh: '再按一次 ? 关闭',
    en: 'Press ? again to close',
    es: 'Pulse ? otra vez para cerrar',
};
/**
 * Full list of shortcuts shown in the `?` overlay.
 * Order matters — most-used first, navigation last.
 */
export const SHORTCUTS = [
    // ── Recording ────────────────────────────────────────────────────────────
    {
        key: 'Space',
        label: {
            zh: '按住录音(松开停)',
            en: 'Hold to record (release to stop)',
            es: 'Mantenga pulsado para grabar (suelte para parar)',
        },
    },
    {
        key: 'Enter',
        label: {
            zh: '提交本条 take',
            en: 'Submit this take',
            es: 'Enviar esta toma',
        },
    },
    {
        key: 'R',
        label: {
            zh: '重录本条(版本 v++)',
            en: 'Re-record this cue (version v++)',
            es: 'Repetir esta toma (versión v++)',
        },
    },
    {
        key: 'N',
        label: {
            zh: '下一条',
            en: 'Next cue',
            es: 'Siguiente toma',
        },
    },
    {
        key: 'Esc',
        label: {
            zh: '取消当前 take',
            en: 'Cancel current take',
            es: 'Cancelar la toma actual',
        },
    },
    // ── Block recording ──────────────────────────────────────────────────────
    {
        key: 'B',
        label: {
            zh: '接受连录建议',
            en: 'Accept block-record suggestion',
            es: 'Aceptar la sugerencia de grabar en bloque',
        },
    },
    {
        key: 'G',
        label: {
            zh: '录整场 scene',
            en: 'Record full scene',
            es: 'Grabar la escena completa',
        },
    },
    {
        key: 'E',
        label: {
            zh: 'effort/打斗连录',
            en: 'Effort / action block',
            es: 'Bloque de esfuerzo / acción',
        },
    },
    {
        key: 'L',
        label: {
            zh: '选中区间连录',
            en: 'Block-record selected range',
            es: 'Grabar en bloque el rango seleccionado',
        },
    },
    // ── Playback / navigation ────────────────────────────────────────────────
    {
        key: 'A',
        label: {
            zh: '试听参考声',
            en: 'Audition reference voice',
            es: 'Escuchar la voz de referencia',
        },
    },
    {
        key: '1-9',
        label: {
            zh: '跳到第 N 条 cue',
            en: 'Jump to cue N',
            es: 'Saltar a la toma N',
        },
    },
    // ── Help ─────────────────────────────────────────────────────────────────
    {
        key: '?',
        label: {
            zh: '打开/关闭这个面板',
            en: 'Toggle this help panel',
            es: 'Mostrar/ocultar este panel de ayuda',
        },
    },
];
